import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//

import * as stepperComponents from "~/components/stepper";
import Loader from "~/components/modals/loader";
export default {
  components: _extends({}, stepperComponents, {
    Loader: Loader
  }),

  data: function data() {
    return {
      dialog: false,
      loading: false,
      closeNewAffiliation: false,
      loaderMessage: null,
      logout: false
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/reports.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/reports.vue
// module chunks = 3